/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {string} [productHandle] - The product handle to add.
   */
  static addProduct(productId, productHandle = '') {
    productId = String(productId || '');
    let viewedProducts = this.#getProductEntries();

    viewedProducts = viewedProducts.filter((entry) => entry.id !== productId && entry.handle !== productHandle);
    viewedProducts.unshift({ id: productId, handle: productHandle });
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return this.#getProductEntries()
      .map((entry) => entry.id)
      .filter(Boolean);
  }

  static getProductHandles() {
    return this.#getProductEntries()
      .map((entry) => entry.handle)
      .filter(Boolean);
  }

  static #getProductEntries() {
    const storedProducts = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    if (!Array.isArray(storedProducts)) return [];

    return storedProducts
      .map((entry) => {
        if (typeof entry === 'string') return { id: entry, handle: '' };
        if (!entry || typeof entry !== 'object') return null;

        return {
          id: typeof entry.id === 'string' ? entry.id : String(entry.id || ''),
          handle: typeof entry.handle === 'string' ? entry.handle : '',
        };
      })
      .filter(Boolean);
  }
}
